import { getProductId } from './cohortUtil';

export const GREENBERG_PROMO_CODE = 'GREENBERG20';
export const GREENBERG_PROMO_QUERY = `promo=${GREENBERG_PROMO_CODE}`;
export const GREENBERG_PROMO_DISMISS_KEY = 'syn-greenberg20-banner-dismissed';
export const GREENBERG_FULL_PRICE = '$99';
export const GREENBERG_DISCOUNTED_PRICE = '$79.20';

export const getGreenbergProductId = () => getProductId('gberg');

export const hasActiveGreenbergAccess = (subscriptions = {}, userProperties = {}) => {
    const productId = getGreenbergProductId();

    if (subscriptions?.[productId]) return true;

    const purchaseDate = userProperties?.[productId];
    if (!purchaseDate) return false;

    const purchasedAt = new Date(purchaseDate);
    if (Number.isNaN(purchasedAt.getTime())) return false;

    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);

    return purchasedAt >= oneYearAgo;
}
